/*
 * Created on Tue Nov 21 2017
 *
 * Copyright (c) 2017 Sébastien Hecart
 */
//gaz
export function cValue(pressionAtmospherique: number, pressionGaz: number, temperatureGaz: number): number {
  return ((pressionAtmospherique + pressionGaz) / 1013) * (273.0 / (273.0 + temperatureGaz))
}
export function debitNormaux(puissNominaleChaudiere: number, pci: number): number {
  //puissanceChaud / pci
  return puissNominaleChaudiere / pci
}
//(Po/(PressionAtmo+pressionGaz))*((TO+tempGaz)/To)*QV0=debitcalo
export function debitGazReel(pressionAtmopsherique: number, pressionGaz: number, temperatureGaz: number, debitNorm: number): number {
  return debitNorm * (1013.0 / (pressionAtmopsherique + pressionGaz)) * ((273 + temperatureGaz) / 273)
}
export function debitTopGaz36s(debitGz: number): number {
  //debitReel *(1000 / 3600) *36
  return debitGz / 100
}
export function puissanceChaudiere(debitCompteur: number, pci: number, cVal: number): number {
  return debitCompteur * pci * cVal
}
export function volumeEauFroide(dimension: number, longueur: number): number {
  return Math.PI * Math.pow(dimension, 2) * 25 * longueur * 10
}
export function tempsAttenteAvantEauChaudeSimple(volumeEauFroid: number, debit: number): number {
  return (volumeEauFroid / debit) * 60
}
export function tempsAttenteAvantEauChaude(dimension: number, longueur: number, debit: number): number {
  return tempsAttenteAvantEauChaudeSimple(volumeEauFroide(dimension, longueur), debit)
}
export function puissanceThermiqueECS(debit10mn: number, tempEauChaude: number, tempArriveEauFroid: number): number {
  return (1.163 * debit10mn * 6 * (tempEauChaude - tempArriveEauFroid)) / 1000
}
export function nombreReynolds(debit: number, diametreTuyaux: number, viscositeCinematiqueCtS: number): number {
  return (4 * debit) / (((3600 * Math.PI * diametreTuyaux) / 1000) * viscositeCinematiqueCtS * 0.000001)
}
export function calculVitesseTuyaux(debit: number, diametre: number): number {
  return (4 * debit) / (3600 * Math.PI * Math.pow(diametre / 1000, 2))
}

//methode de perte de charge colebrook
/**
 * It calculates the friction factor for a pipe using the Colebrook equation
 * @param {number} reynolds - Reynolds number
 * @param {number} rugosite - roughness of the pipe
 * @param {number} diametre_interieur - the inner diameter of the pipe
 * @returns The friction factor
 */
export function colebrook(reynolds: number, rugosite: number, diametre_interieur: number): number {
  let step3 = rugosite / (diametre_interieur * 3.7)
  var tpfci = 0.0
  var tpfc = 0.1 / ((3.7 * 263.1) / 1000)
  while (Math.abs(tpfc - tpfci) > 1e-6) {
    tpfci = tpfc
    tpfc = Math.pow(-1 / (2 * Math.log10(2.51 / (reynolds * Math.sqrt(tpfci)) + step3)), 2)
  }
  return tpfc
}
